import './index.sass';

import React from 'react';
import { Form, Page, Button, Container, Row, Col, Spinner } from '../../components';
import { Query } from '../../utils';
import Dropdown from 'react-bootstrap/Dropdown';
import ListGroup from 'react-bootstrap/ListGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import List from './list.js';
import classNames from 'classnames';
import trash from './images/trash-3.svg';
import sprintf from 'yow/sprintf';
import { ButtonGroup, PopoverBody } from 'react-bootstrap';
import Overlay from 'react-bootstrap/Overlay';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip';
import Popup from '../../components/popup';
import PopupMenu from '../../components/popup-menu';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import './index.sass';

export default class extends React.Component {
	constructor(props) {
		super(props);

		this.log = console.log;
		this.debug = console.log;

		this.state = {};
		this.query = new Query();
		this.state.rows = null;
		this.state.columns = [];
		this.state.search = '';
		this.state.filter = '';
		this.state.sortBy = 0;
		this.state.sortOrder = 'ascending';
		this.list = React.createRef();
		this.state.view = 'overview';
		this.state.key = 0;

		this.state.columns = this.createColumns(this.state.view);
	}

	createColumns(view) {
		let columns = [
			{ name: 'Ticker', value: (row) => row.symbol },
			{ name: 'Namn', value: (row) => row.name },
			{ name: 'Branch', value: (row) => row.sector },
			{ name: 'Industri', value: (row) => row.industry },
			{ name: 'Uppdaterad', value: (row) => row.timestamp, type: 'datetime' },
		];

		switch (view) {
			case 'statistics': {
				columns = [
					{ name: 'Ticker', value: (row) => row.symbol },
					{ name: 'Namn', value: (row) => row.name },
					{ name: 'AV14', value: (row) => row.AV14, type: 'number' },
					{ name: 'ATR14', value: (row) => row.ATR14, type: 'number' },
					{ name: 'WH51', value: (row) => row.WH51, type: 'number' },
					{ name: 'WL51', value: (row) => row.WL51, type: 'number' },
					{ name: 'SMA10', value: (row) => row.SMA10, type: 'number' },
					{ name: 'SMA20', value: (row) => row.SMA20, type: 'number' },
					{ name: 'SMA200', value: (row) => row.SMA200, type: 'number' },
					{ name: 'DOG200', value: (row) => row.DOG200, type: 'date' },
				];
				break;
			}
			case 'value': {
				columns = [
					{ name: 'Ticker', value: (row) => row.symbol },
					{ name: 'Namn', value: (row) => row.name },
					{ name: 'Datum', value: (row) => row.date, type: 'date' },
					{ name: 'Högst', value: (row) => row.high, type: 'number' },
					{ name: 'Lägst', value: (row) => row.low, type: 'number' },
					{ name: 'Senast', value: (row) => row.close, type: 'number' },
				];
				break;
			}
		}

		console.log(columns);
		return columns;
	}

	getList() {
		return this.list.current;
	}

	fetch() {
		try {
			let query = `SELECT * FROM stocks LIMIT 100`;

			if (this.state.search != '') {
				query = `SELECT * FROM stocks WHERE name LIKE '%${this.state.search}%' OR symbol LIKE '%${this.state.search}%' LIMIT 100`;
			}

			this.query.fetch(query).then((rows) => {
				this.debug(`Query ${query} returned ${rows.length} results.`);
				this.setState({ rows: rows, filter: '' });
			});
		} catch (error) {
			console.log(error.message);
		}
	}

	componentDidMount() {
		this.fetch();
	}

	renderForm() {
		let onSearchChange = async (event) => {
			let target = event.target;
			let value = target.value;
			this.setState({ search: value });
		};

		let onSearchClick = (event) => {
			try {
				this.setState({ rows: null });
				this.fetch();
			} catch (error) {}
		};

		let onKeyDown = (event) => {
			if (event.keyCode == 13) {
				onSearchClick();
			}
		};

		let popupClick = (param) => {
			this.getList().setColumns(this.createColumns(param));
			this.setState({ view: param });
		};

		return (
			<Form className='pb-3'>
				<Row>
					<Col>
						<Form.Control placeholder='Sök efter ticker eller namn' type='text' value={this.state.search} onKeyDown={onKeyDown} onChange={onSearchChange}></Form.Control>
					</Col>

					<Col xs='auto' className='text-end'>
						<Button variant='primary' onClick={onSearchClick}>
							Sök
						</Button>
					</Col>
				</Row>
			</Form>
		);
	}

	onOrderChange(order) {
		console.log('onOrderChange', order);
		console.log('rows', this.getList().getRows());
	}
	onSelectionChange(selection) {
		this.setState({ selection: selection });
		console.log('Selected rows', this.getList().getSelectedRows());
	}
	onFilterChange(filter) {
		this.setState({ filter: filter });
		console.log('onFilterChange', filter, this.getList().getRows());
	}

	renderTabs() {
		let onSelect = (param) => {
			console.log(param);
			this.getList().setColumns(this.createColumns(param));
			this.setState({ view: param });
		};

		return (
			<Tabs className='mb-2' onSelect={onSelect}>
				<Tab eventKey='overview' title='Översikt' />
				<Tab eventKey='statistics' title='Statistik' />
				<Tab eventKey='value' title='Slutkurser' />
			</Tabs>
		);
	}

	renderList() {
		let style = {};
		style.border = 'var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)';
		style.borderRadius = 'var(--bs-border-radius)';
		style.overflowY = 'auto';

		let renderSpinner = () => {
			return (
				<div className='d-flex flex-column justify-content-center align-items-center h-100'>
					<Spinner className='' animation='grow'></Spinner>
				</div>
			);
		};

		let renderList = () => {
			return <List ref={this.list} rows={this.state.rows} columns={this.state.columns} onFilterChange={this.onFilterChange.bind(this)} onSelectionChange={this.onSelectionChange.bind(this)} onOrderChange={this.onOrderChange.bind(this)} selectionStyle='multiple'></List>;
		};

		return (
			<div className='h-100' style={style}>
				{this.state.rows ? renderList() : renderSpinner()}
			</div>
		);
	}

	renderFilter() {
		if (typeof this.state.filter != 'string') {
			return;
		}

		let props = {};
		props.value = this.state.filter;
		props.style = {};
		props.style.fontSize = '90%';

		props.onChange = (event) => {
			this.getList().filter(event.target.value);
		};

		return (
			<div className='input-group pt-2 pb-2'>
				<input type='text' placeholder='Snabbfilter' className='form-control' {...props}></input>
			</div>
		);
	}

	render() {
		return (
			<div>
				<div className='container fixed-bottom fixed-top d-flex flex-column'>
					<div className='pt-4 pb-0'>
						<h4 className=''>Aktier</h4>
					</div>

					<div className=''>
						{this.renderForm()}
						{this.renderTabs()}
					</div>

					<div className='flex-grow-1' style={{ minHeight: '10rem' }}>
						{this.renderList()}
					</div>
					<div className=''>{this.renderFilter()}</div>
				</div>
			</div>
		);
	}

	zrender() {
		return (
			<Container>
				<h4>Aktier</h4>

				{this.renderForm()}
				{this.renderTabs()}
				{this.renderList()}
				{this.renderFilter()}
			</Container>
		);
	}

	xcrender() {
		return (
			<div style={{}}>
				<div style={{ flexShrink: '0' }}>
					<h4>Aktier</h4>
					{this.renderForm()}
					{this.renderTabs()}
				</div>
				<div style={{ position: 'absolute', top: '10rem', bottom: 0, left: 0, right: 0, background: 'red' }}>HEJ</div>
			</div>
		);
	}
}
